import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { BuyMusicChannelRequest } from './buymusicchannelrequest';

export class BuyMusicChannelAPI extends SixdeeCRBTAPI<BuyMusicChannelRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/buy-music-channel
        return "buy-music-channel";
    }
//serviceId=7&aPartyMsisdn=0504843969&toneId=6015090011&language=English&priority=0&paymentMode=2
    getRequestData()
    {
        return "serviceId="+ this.getRequest().getBuyMusicChannelRequest().getServiceId()+"&"+
               "aPartyMsisdn="+ this.getRequest().getBuyMusicChannelRequest().getAPartyMsisdn()+"&"+
               "toneId="+ this.getRequest().getBuyMusicChannelRequest().getToneId()+"&"+
               "language="+ this.getRequest().getBuyMusicChannelRequest().getLanguage()+"&"+
               "priority="+ this.getRequest().getBuyMusicChannelRequest().getPriority()+"&"+
               "paymentMode="+ this.getRequest().getBuyMusicChannelRequest().getPaymentMode()+"&"+
               "clientTxnId=30062020";
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/buymusicchannel/buymusicchannelapi.tsx